import React from 'react';
import EvaluatorPaymentItem from '../../../../Domain/EvaluatorPaymentItem';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import CurrencyNoteTextsEnum from '../../../../Enums/CurrencyNoteTextsEnum';
import ValidityHelper from '../../../../Helpers/ValidityHelper';
import EvaluatorPaymentService from '../../../../Services/EvaluatorPaymentService';

export default class EditEvaluatorPaymentWindowDescription extends React.Component {
  static titleForCreate = 'New Payment Request';
  static titleForEdit = 'Edit Evaluator Payment';
  static itemType = EvaluatorPaymentItem;
  static serviceFunction = (edited) => EvaluatorPaymentService.UpsertEvaluatorPayment(edited);

  getSelected() {}

  getSearchParameters() {}

  getAllItemInTheSearchAreSelected() {}

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: (item) => EditEvaluatorPaymentWindowDescription.getCurrency(item),
          label: 'Currency',
          tooltipText: CurrencyNoteTextsEnum.EvaluatorPaymentEdit,
          className: 'col-6',
          type: InputTypesEnum.TextReadOnly,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) =>
            item.IeType === 'Payment Request' || (item.IeType === 'Advance Payment' && item.IeStatus !== 'Created'),
        },
        {
          fieldName: 'IeFee',
          label: 'Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.IeType === 'Payment Request' && item.IeStatus !== 'Created') || item.IeType === 'Advance Payment',
        },
        {
          fieldName: 'IeFeeAdjustment',
          label: 'Additional Fee',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.IeType === 'Payment Request' && item.IeStatus !== 'Created') || item.IeType === 'Advance Payment',
        },
        {
          fieldName: 'IeReimbursement',
          label: 'Reimbursement',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) => ['Payment Request', 'Advance Payment'].includes(item.IeType) && item.IeStatus !== 'Created',
        },
        {
          fieldName: 'IeMisc',
          label: 'Misc',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.IeType === 'Payment Request' && item.IeStatus !== 'Created') || item.IeType === 'Advance Payment',
        },
        {
          fieldName: 'IeTravel',
          label: 'Travel',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.IeType === 'Payment Request' && item.IeStatus !== 'Created') || item.IeType === 'Advance Payment',
        },
        {
          fieldName: 'IeGaming',
          label: 'Gaming',
          className: 'col-12',
          type: InputTypesEnum.NumberWithTwoDecimalPlaces,
          validityChecker: ValidityHelper.forRequiredNumberFieldAtLeastZero,
          hide: (item) =>
            (item.IeType === 'Payment Request' && item.IeStatus !== 'Created') || item.IeType === 'Advance Payment',
        },
        {
          fieldName: 'IeAssignedTo',
          label: 'Assigned To *',
          className: 'col-12',
          type: InputTypesEnum.UserSelect,
          validityChecker: ValidityHelper.AlwaysFlawless,
          roleKey: 'evaluatorpayment_editassignee',
          hide: (item) => !['Payment Request', 'Advance Payment'].includes(item.IeType),
        },
        {
          fieldName: 'IeComment',
          label: 'Comment',
          className: 'col-12',
          type: InputTypesEnum.TextBox,
          validityChecker: ValidityHelper.AlwaysFlawless,
          hide: (item) => ['Payment Request', 'Advance Payment'].includes(item.IeType) && item.IeStatus !== 'Created',
        },
      ],
    },
  ];

  static getCurrency(item) {
    return `${item.IeRcyName} (${item.IeRcysymbol})`;
  }
}
